import { Icon, Text } from "@shopify/polaris"
import { StarFilledIcon, StarIcon } from "@shopify/polaris-icons"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import styles from "./SimpleReviewGuide.module.scss"

interface SimpleReviewGuideProps {
  value?: number
  onChange?: (rating: number) => void
  disabled?: boolean
}

const SimpleReviewGuide = ({ value = 0, onChange, disabled = false }: SimpleReviewGuideProps) => {
  const { t } = useTranslation("common")
  const [hoverRating, setHoverRating] = useState(0)

  const handleStarClick = (rating: number) => {
    if (disabled) return
    onChange?.(rating)
  }

  const handleStarHover = (rating: number) => {
    if (disabled) return
    setHoverRating(rating)
  }

  const handleStarLeave = () => {
    if (disabled) return
    setHoverRating(0) // 重置为0，这样会显示用户实际选择的星级
  }

  const renderStar = (index: number) => {
    const starNumber = index + 1
    // 关键逻辑：如果有hover状态显示hoverRating，否则显示用户选择的value
    const isFilled = hoverRating > 0 ? starNumber <= hoverRating : starNumber <= value
    
    return (
      <div 
        key={index}
        className={`${styles.IconWrapper} ${disabled ? styles.disabled : ""}`}
        onClick={() => handleStarClick(starNumber)}
        onMouseEnter={() => handleStarHover(starNumber)}
        onMouseLeave={handleStarLeave}
      >
        <Icon 
          source={isFilled ? StarFilledIcon : StarIcon} 
          tone="info" 
        />
      </div>
    )
  }

  return (
    <div className={"flex justify-center gap-2 flex-col"}>
      <Text as={"p"} variant={"bodyMd"} fontWeight={"medium"}>
        {t("ReviewGuide")}
      </Text>
      <div className={"flex gap-0.5 justify-center"}>
        {Array.from({ length: 5 }, (_, index) => renderStar(index))}
      </div>
    </div>
  )
}

export default SimpleReviewGuide
